import { client } from './client'

const sweepAll = async () => {
  try {
    let resource = `/api/v1/cache/purge/all`
    let response = await client.get(resource)
    return response.data
  } catch (error) {
    throw error
  }
}

const sweepAllByKey = async (key) => {
  try {
    let resource = `/api/v1/cache/purge/all/${key}`
    let response = await client.get(resource)
    return response.data
  } catch (error) {
    throw error
  }
}

export {
  sweepAll,
  sweepAllByKey
}



// WEBPACK FOOTER //
// ./src/api/web/index.js